export enum SortingKeys {
  ascend = 'ascend',
  descend = 'descend',
}
